import s from 'string'

import sublevel from '@/services/SubLevelAdapterService'
import encrypt from '@/services/EncryptionService'
import ApplicationException from '@/errors/ApplicationException'

const module = {
  namespaced: true, // user/login
  state: () => ({
    user: {
      name: null,
      password: null
    },
    err: false
  }),
  getters: {
    users: (state, getters, rootState, rootGetters) => rootGetters.isConnected ? sublevel.sub(rootState.schema, 'users', { keyEncoding: 'utf8', valueEncoding: 'json' }) : null,
    isLoggedIn: (state, getters, rootState, rootGetters) => (state.user.name !== null),
    isLoggedOut: (state, getters, rootState, rootGetters) => (state.user.name === null),
    hasErr: (state, getters, rootState, rootGetters) => (state.err !== false)
  },
  mutations: {
    LOGIN (state, name) {
      state.user.name = name
      state.user.password = null
      state.err = false
    },
    LOGOUT (state) {
      state.user.name = null
      state.user.password = null
      state.err = false
    },
    LOGIN_ERR (state, err) {
      state.err = err
    },
    RESET (state) {
      // state.user.name = null
      state.user.password = null
      state.err = false
    }
  },
  actions: {
    async login ({ state, rootState, commit, dispatch, getters, rootGetters }, opts) {
      if (getters.isLoggedIn) return

      let users = getters.users
      let username = opts.username
      let password = opts.password

      try {
        // TODO: Validations could be moved elsewhere?
        if (s(username).isEmpty()) throw ApplicationException('Username is required', 'CredentialsInvalid')
        if (s(username).length < 5) throw ApplicationException('Username should be minimum 5 characters', 'CredentialsInvalid')
        if (s(username).length > 20) throw ApplicationException('Username should be maximum 20 characters', 'CredentialsInvalid')
        if (s(password).isEmpty()) throw ApplicationException('Password is required', 'CredentialsInvalid')
        if (s(password).length < 5) throw ApplicationException('Password should be minimum 5 characters', 'CredentialsInvalid')
        if (s(password).length > 20) throw ApplicationException('Password should be maximum 20 characters', 'CredentialsInvalid')

        let reply = await users.get(username)

        let canLogin = encrypt.isHashSame(password, reply.salt, reply.password)
        if (!canLogin) throw new ApplicationException('Invalid username/password', 'CredentialsInvalid')

        commit('LOGIN', username)
      } catch (e) {
        commit('LOGIN_ERR', e.message)
        throw e
      }
    },
    async logout ({ state, rootState, commit, dispatch, getters, rootGetters }, opts) {
      commit('LOGOUT')
    },
    async reset ({ state, rootState, commit, dispatch, getters, rootGetters }, opts) {
      commit('RESET')
    }
  },
  modules: {}
}

export default module
